import { useMemo } from 'react'
import { PageStatusFilters } from '../../RestockingTypes'
import { fixInputSx } from '../../utils'
import * as S from './FormManageFilterLists.styles'

const filterStatusLists = [PageStatusFilters.ALL_OPTIONS, PageStatusFilters.CLOSED, PageStatusFilters.OPENED]

interface FormManageFilterListsProps {
  statusRestockingLists: number,
  setStatusRestockingLists: React.Dispatch<React.SetStateAction<number>>
}

export const FormManageFilterLists = ({
  statusRestockingLists,
  setStatusRestockingLists,
}: FormManageFilterListsProps) => {
  const filterStatusListsOptions = useMemo(() => filterStatusLists.map((type, index) => ({
    description: type,
    id: index,
  })), [])

  return (
    <S.CustomSelect
      formControlSx={fixInputSx}
      autoComplete='off'
      dataTestId='status-restocking-lists-select'
      id='statusRestockingLists'
      name='statusRestockingLists'
      label='Status da lista'
      variant='outlined'
      options={filterStatusListsOptions}
      size='medium'
      type='text'
      optionNone={false}
      fullWidth
      defaultValue={statusRestockingLists}
      onChange={(event) => setStatusRestockingLists(event.target.value as number)}
    />
  )
}
